import React, { FunctionComponent, useState } from 'react';
import ReactVisibilitySensor from 'react-visibility-sensor';
import { CircularSpinner } from '../CircularSpinner/CircularSpinner';
interface Shape {
  top?: number;
  left?: number;
  bottom?: number;
  right?: number;
}

const LoaderComponent: React.FC<{ loader?: React.ReactElement }> = ({ loader }) => loader || <CircularSpinner/>;

const RenderWhenVisible: FunctionComponent<{ loader?: React.ReactElement, offset?: Shape
}> = ({loader, offset, children}) => {

  const [wasComponentRenderOnce, setWasComponentRenderOnce] = useState(false);

  function onVisibilityChange(isVisible: boolean): void {
    if (isVisible) {
      setWasComponentRenderOnce(true);
    }
  }


  return (
      <ReactVisibilitySensor offset={offset} onChange={onVisibilityChange}>
          {!wasComponentRenderOnce ? <LoaderComponent loader={loader} /> : children }
      </ReactVisibilitySensor>
  );
};

export { RenderWhenVisible };
